import { render, staticRenderFns } from "./translatedMultiselect.vue?vue&type=template&id=670467ea&"
import script from "./translatedMultiselect.vue?vue&type=script&lang=js&"
export * from "./translatedMultiselect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports